import React from "react";
import PropTypes from "prop-types";
import { Button, Spinner } from "reactstrap";
import { BULK_UPLOAD_MESSAGES } from "../Json/BulkUploadMessages";
import { formatFileSize } from "../Utils/fileUtils";

const { file: fileMessages } = BULK_UPLOAD_MESSAGES;

/** The chosen file, with the actions that can be taken on it. */
const SelectedFileCard = ({ file, isUploading, onRemove, onUpload }) => (
  <div className="border rounded-3 mt-3 p-3 d-flex align-items-center justify-content-between flex-wrap gap-3">
    <div className="d-flex align-items-center gap-3 min-w-0">
      <i className="ri-file-excel-2-fill text-success fs-3" />
      <div className="min-w-0">
        <h6 className="mb-0 text-truncate">{file.name}</h6>
        <small className="text-muted">{formatFileSize(file.size)}</small>
      </div>
    </div>

    <div className="d-flex align-items-center gap-2">
      <Button color="light" size="sm" onClick={onRemove} disabled={isUploading}>
        {fileMessages.remove}
      </Button>

      <Button color="primary" size="sm" onClick={onUpload} disabled={isUploading}>
        {isUploading ? (
          <>
            <Spinner size="sm" className="me-2" />
            {fileMessages.uploading}
          </>
        ) : (
          <>
            <i className="ri-upload-cloud-2-line me-1" />
            {fileMessages.upload}
          </>
        )}
      </Button>
    </div>
  </div>
);

SelectedFileCard.propTypes = {
  file: PropTypes.shape({
    name: PropTypes.string.isRequired,
    size: PropTypes.number.isRequired,
  }).isRequired,
  isUploading: PropTypes.bool.isRequired,
  onRemove: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
};

export default SelectedFileCard;
